import React from 'react'
import { Box, Typography } from '@material-ui/core'
import {
    Cidot,
    Citext,
    Colorindicator,
    Customprogressbar,
    LightTooltip
} from 'assets/engagementStyle'
import { customColor } from '../../assets/globalComponent'

export default function Enprogressbar({ item }) {
    return (
        <Customprogressbar>
            <Box>
                <LightTooltip
                    title={
                        <>
                            <Typography align="center">
                                <strong>
                                    Positive Responses:{' '}
                                    {(
                                        item.satisfied + item.very_satisfied
                                    ).toFixed()}{' '}
                                    %
                                </strong>
                            </Typography>
                            <Customprogressbar sx={{ mt: 1 }}>
                                <Box>
                                    <Box
                                        style={{
                                            width:
                                                (item?.very_satisfied).toString() +
                                                '%',
                                            backgroundColor:
                                                customColor.StronglyPositive
                                        }}
                                    >
                                        {item.very_satisfied.toFixed()} %
                                    </Box>
                                    <Box
                                        style={{
                                            width:
                                                (item?.satisfied).toString() +
                                                '%',
                                            backgroundColor:
                                                customColor.Positive,
                                            borderRadius: '0 5px 5px 0'
                                        }}
                                    >
                                        {item.satisfied.toFixed()} %
                                    </Box>
                                </Box>
                            </Customprogressbar>
                            <Colorindicator>
                                <Box>
                                    <Cidot
                                        bgcolor={customColor.StronglyPositive}
                                    ></Cidot>
                                    <Citext>Strongly Positive</Citext>
                                </Box>
                                <Box>
                                    <Cidot
                                        bgcolor={customColor.Positive}
                                    ></Cidot>
                                    <Citext>Positive</Citext>
                                </Box>
                            </Colorindicator>
                        </>
                    }
                    placement="top"
                    interactive
                >
                    <Box
                        style={{
                            width:
                                (
                                    item?.satisfied + item?.very_satisfied
                                ).toString() + '%',
                            backgroundColor: customColor.Positive
                        }}
                    >
                        <span></span>
                    </Box>
                </LightTooltip>
                <LightTooltip
                    title={
                        <>
                            <Typography align="center">
                                <strong>
                                    Neutral Responses: {item.neutral.toFixed()}{' '}
                                    %
                                </strong>
                            </Typography>
                        </>
                    }
                    placement="top"
                    interactive
                >
                    <Box
                        style={{
                            width: item?.neutral.toString() + '%',
                            backgroundColor: customColor.DataProtected4
                        }}
                    ></Box>
                </LightTooltip>
                <LightTooltip
                    title={
                        <>
                            <Typography align="center">
                                <strong>
                                    Negative Responses:{' '}
                                    {(
                                        item.not_satisfied +
                                        item.slightly_satisfied
                                    ).toFixed()}{' '}
                                    %
                                </strong>
                            </Typography>
                            <Customprogressbar sx={{ mt: 1 }}>
                                <Box>
                                    <Box
                                        style={{
                                            width:
                                                (item?.slightly_satisfied).toString() +
                                                '%',
                                            backgroundColor: customColor.Red2
                                        }}
                                    >
                                        {item.slightly_satisfied.toFixed()} %
                                    </Box>
                                    <Box
                                        style={{
                                            width:
                                                (item?.not_satisfied).toString() +
                                                '%',
                                            backgroundColor: customColor.Red,
                                            borderRadius: '0 5px 5px 0'
                                        }}
                                    >
                                        {item.not_satisfied.toFixed()} %
                                    </Box>
                                </Box>
                            </Customprogressbar>
                            <Colorindicator>
                                <Box>
                                    <Cidot bgcolor={customColor.Red2}></Cidot>
                                    <Citext>Negative</Citext>
                                </Box>
                                <Box>
                                    <Cidot bgcolor={customColor.Red}></Cidot>
                                    <Citext>Strongly Negative</Citext>
                                </Box>
                            </Colorindicator>
                        </>
                    }
                    placement="top"
                    interactive
                >
                    <Box
                        style={{
                            width:
                                (
                                    item?.not_satisfied +
                                    item?.slightly_satisfied
                                ).toString() + '%',
                            backgroundColor: customColor.Red2
                        }}
                    >
                        <span></span>
                    </Box>
                </LightTooltip>
            </Box>
        </Customprogressbar>
    )
}
